import { useQuery, useQueryClient } from "react-query";
import api from "../../services/api";

// staleTime alinhado com o cron de agregação 3h no backend.
const STALE_TIME_MS = 3 * 60 * 60 * 1000;
const CACHE_TIME_MS = 24 * 60 * 60 * 1000;

const buildParams = (filters, includeCompanyIds, groupName) => {
  const params = {
    startDate: filters.startDate,
    endDate: filters.endDate,
  };
  if (includeCompanyIds && filters.companyIds?.length) {
    params.companyIds = filters.companyIds.join(",");
  }
  if (filters.whatsappIds?.length) params.whatsappIds = filters.whatsappIds.join(",");
  if (filters.provider) params.provider = filters.provider;
  if (groupName) params.groupName = groupName;
  return params;
};

export const useMessageStats = (
  filters,
  {
    endpoint = "/super-dashboard/messages-stats",
    refreshEndpoint = "/super-dashboard/messages-stats/refresh",
    includeCompanyIds = true,
    enabled = true,
    groupName,
  } = {}
) => {
  const queryClient = useQueryClient();
  // Endpoint entra na key pra que SuperAdminPanel e Dashboard mantenham
  // caches separados quando ambos forem abertos na mesma sessão.
  const queryKey = ["message-stats", endpoint, filters, groupName];

  const fetchMessageStats = async (refresh = false) => {
    const params = buildParams(filters, includeCompanyIds, groupName);
    if (refresh) params.refresh = 1;
    const { data } = await api.get(endpoint, { params });
    return data;
  };

  const query = useQuery(queryKey, () => fetchMessageStats(false), {
    staleTime: STALE_TIME_MS,
    cacheTime: CACHE_TIME_MS,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: enabled && !!filters.startDate && !!filters.endDate,
  });

  // POST /refresh força nova agregação (rolling 3d) no backend antes de
  // re-buscar — sem isso, lastUpdatedAt nunca avançaria entre cron ticks.
  // groupName precisa ir junto pra o middleware resolveGroupOrSingle entrar
  // em modo grupo nessa rota também; sem ele o backend cai no companyId do
  // JWT e a invalidação fica desalinhada com o GET (que mandou groupName).
  const refresh = async () => {
    const params = buildParams(filters, includeCompanyIds, groupName);
    try {
      await api.post(refreshEndpoint, null, { params });
    } catch (e) { /* segue mesmo se falhar — re-fetch ainda traz dados antigos */ }
    await queryClient.invalidateQueries(queryKey);
    return queryClient.fetchQuery(queryKey, () => fetchMessageStats(true), {
      staleTime: STALE_TIME_MS,
    });
  };

  return { ...query, refresh };
};
